<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="$t('product.text0')"></navBox>
			<!--导航-->
			<!--banner-->
			<div v-if="bannerList" class="banner_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<van-swipe class="swipe_box" :autoplay="5000" :show-indicators="false" :stop-propagation="false" @change="bannerChange">
					<van-swipe-item v-for="(value, index) in bannerList" :key="index">
						<div class="swiper_el">
							<img class="bg" :src="value.imgUrl" @dragstart.prevent />
							<div class="msg_box">
								<div class="tit_b">{{ $t('product.text1') }}</div>
								<div class="tit">{{ $t('product.text2') }}</div>
								<div class="tips" @click="goProductAll">
									{{ $t('product.text3') }}&nbsp;<van-icon name="arrow" size="16px" color="#000000" style="position: relative;top: 3px;" />
								</div>
							</div>
						</div>
					</van-swipe-item>
				</van-swipe>
				<div v-if="bannerList.length > 1" class="indicators_box">
					<div v-for="(value, index) in bannerList" :key="index" class="indicators_el" :class="bannerIndex == index ? 'actived' : ''"></div>
				</div>
			</div>
			<!--banner-->
			<!--位置块-->
			<div class="location_box"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div class="location_main">
					<van-icon name="wap-home-o" size="20px" color="#000000" style="position: relative;top: 4px;" />&nbsp;
					<span style="cursor: pointer;" @click="goHome">{{ $t('product.text4') }}</span>&ensp;
					<van-icon name="arrow" size="20px" color="#000000" style="position: relative;top: 4px;" />&ensp;
					<span class="actived">{{ $t('product.text5') }}</span>
				</div>
			</div>
			<!--位置块-->
			<!--块1-->
			<div v-if="cateList" class="block_1"
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
			>
				<div
					class="block_1_el"
					v-for="(value, index) in cateList"
					:key="index"
					@click="goProducts(value)"
				>
					<img class="bg" :src="index % 2 == 0 ? require('@/assets/img_public/products/block01.webp') : require('@/assets/img_public/products/block02.webp') " />
					<!-- <div class="tit1">{{ value.en_title }}</div> -->
					<div class="tit2">{{ value.title }}</div>
					<div class="btn_box">
						<div class="public_btn">{{ $t('product.text6') }}<van-icon name="arrow" size="16px" class="btn_icon" /></div>
					</div>
				</div>
			</div>
			<!--块1-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
export default {
	components:{
		navBox,
		footerBox
	},
	data() {
		return {
			isLoading: true,  //界面loading
			bannerList: [
				{ imgUrl: require('@/assets/img_public/products/banner01.webp') }
			],
			bannerIndex: 0,  //当前轮播索引
			cateList: [],
		}
	},
	created(){
		let that = this;
		that.cateList = JSON.parse(sessionStorage.getItem('navList'))[1].children.cate_list;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		//点击首页
		goHome() {
			this.$router.push({ path: '/' });
		},
		goProductAll() {
			this.$router.push({ path: '/product-list.html' });
		},
		goProducts(value) {
			this.$router.push({ path: '/product-list.html', query: { cate_ids: value.id, } });
		},
		//banner变化
		bannerChange(index) {
			let that = this;
			that.bannerIndex = index;
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	//块1
	.block_1{
		width: 1520px;
		margin: 0 auto;
		padding: 60px 0;
		.block_1_el{
			width: 46%;
			height: 500px;
			display: inline-block;
			position: relative;
			margin: 1.5% 2% 1.5% 2%;
			padding: 80px;
			cursor: pointer;
			.bg{
				width: 100%;
				height: 100%;
				position: absolute;
				left: 0;
				top: 0;
				z-index: -1;
				background-size: cover;
			}
			.btn_box{
				position: absolute;
				bottom: 100px;
			}
			.list_box{
				padding: 26px 0 140px 0;
				.list_el{
					display: inline-block;
					margin: 0 30px 12px 0;
					font-size: 18px;
					cursor: pointer;
				}
			}
			.tit2{
				font-size: 32px;
				font-weight: bold;
			}
			.tit1{
				font-size: 28px;
				color: #A20073;
				opacity: 0.1;
			}
		}
	}
	//轮播
	.banner_box{
		min-width: 1200px;
		position: relative;
		.indicators_box{
			position: absolute;
			bottom: 50px;
			left: 50%;
			transform: translate(-50%, 0);
			.indicators_el{
				width: 100px;
				height: 2px;
				display: inline-block;
				margin: 0 5px;
				background-color: rgba(0, 0, 0, 0.3);
			}
			.actived{
				background-color: #A20073;
			}
		}
		.swipe_box{
			.swiper_el{
				position: relative;
				.msg_box{
					width: 1264px;
					margin: 0 auto 0 auto;
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					text-align: right;
					.tips{
						margin-top: 40px;
						display: inline-block;
						font-size: 16px;
						padding: 8px 16px;
						border-radius: 8px;
						border: 1px solid #999999;
					}
					.tit{
						margin-top: 10px;
						font-size: 16px;
						color: #A50073;
					}
					.tit_b{
						font-size: 40px;
						font-weight: bold;
						color: #A50073;
					}
				}
				img.bg{
					width: 100%;
				}
			}
		}
	}
}
</style>